const HeaderSection = {
    classNames: {
        logoImage: 'header__logo',
        logoLink: 'header__logo-link'
    }
};

export default HeaderSection;
